/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Androidbeta_Registered1Inputs */

const id_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda terdaftar!`)
};

const ms_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda didaftarkan!`)
};

const da_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du er registreret!`)
};

const de_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie sind registriert!`)
};

const en_us2_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are registered!`)
};

const es_es2_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Estás registrado!`)
};

const es_mx2_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Estás registrado!`)
};

const fil_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikaw ay rehistrado!`)
};

const fr_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous êtes inscrit !`)
};

const it_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrazione completata!`)
};

const hu_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regisztráltál!`)
};

const nl_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je bent geregistreerd!`)
};

const no_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du er registrert!`)
};

const pl_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jesteś zarejestrowany!`)
};

const pt_br2_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are registered!`)
};

const pt_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Está registado!`)
};

const ro_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ești înregistrat!`)
};

const fi_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olet rekisteröitynyt!`)
};

const sv_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du är registrerad!`)
};

const vi_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn đã đăng ký!`)
};

const tr_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaydoldunuz!`)
};

const cs_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jste zaregistrováni!`)
};

const bg_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Регистрирани сте!`)
};

const ru_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы зарегистрированы!`)
};

const uk_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви зареєстровані!`)
};

const ar_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنت مسجل!`)
};

const hi_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पंजीकृत!`)
};

const th_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณลงทะเบียนแล้ว!`)
};

const ja_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登録完了！`)
};

const zh_cn2_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are registered!`)
};

const zh_hant1_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are registered!`)
};

const ko_forms_androidbeta_registered1 = /** @type {(inputs: Forms_Androidbeta_Registered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are registered!`)
};

/**
* | output |
* | --- |
* | "You are registered!" |
*
* @param {Forms_Androidbeta_Registered1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_androidbeta_registered1 = /** @type {((inputs?: Forms_Androidbeta_Registered1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Androidbeta_Registered1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_androidbeta_registered1(inputs)
	if (locale === "ms") return ms_forms_androidbeta_registered1(inputs)
	if (locale === "da") return da_forms_androidbeta_registered1(inputs)
	if (locale === "de") return de_forms_androidbeta_registered1(inputs)
	if (locale === "en-US") return en_us2_forms_androidbeta_registered1(inputs)
	if (locale === "es-ES") return es_es2_forms_androidbeta_registered1(inputs)
	if (locale === "es-MX") return es_mx2_forms_androidbeta_registered1(inputs)
	if (locale === "fil") return fil_forms_androidbeta_registered1(inputs)
	if (locale === "fr") return fr_forms_androidbeta_registered1(inputs)
	if (locale === "it") return it_forms_androidbeta_registered1(inputs)
	if (locale === "hu") return hu_forms_androidbeta_registered1(inputs)
	if (locale === "nl") return nl_forms_androidbeta_registered1(inputs)
	if (locale === "no") return no_forms_androidbeta_registered1(inputs)
	if (locale === "pl") return pl_forms_androidbeta_registered1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_androidbeta_registered1(inputs)
	if (locale === "pt") return pt_forms_androidbeta_registered1(inputs)
	if (locale === "ro") return ro_forms_androidbeta_registered1(inputs)
	if (locale === "fi") return fi_forms_androidbeta_registered1(inputs)
	if (locale === "sv") return sv_forms_androidbeta_registered1(inputs)
	if (locale === "vi") return vi_forms_androidbeta_registered1(inputs)
	if (locale === "tr") return tr_forms_androidbeta_registered1(inputs)
	if (locale === "cs") return cs_forms_androidbeta_registered1(inputs)
	if (locale === "bg") return bg_forms_androidbeta_registered1(inputs)
	if (locale === "ru") return ru_forms_androidbeta_registered1(inputs)
	if (locale === "uk") return uk_forms_androidbeta_registered1(inputs)
	if (locale === "ar") return ar_forms_androidbeta_registered1(inputs)
	if (locale === "hi") return hi_forms_androidbeta_registered1(inputs)
	if (locale === "th") return th_forms_androidbeta_registered1(inputs)
	if (locale === "ja") return ja_forms_androidbeta_registered1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_androidbeta_registered1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_androidbeta_registered1(inputs)
	return ko_forms_androidbeta_registered1(inputs)
});
export { forms_androidbeta_registered1 as "forms.androidBeta.registered" }